





















































































import {Vue, Component} from "vue-property-decorator";
import dataProxy from "../../../services/data-proxy.service";
import {Oprema} from "../../../services/BackendProxies";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({
    components: {
        Datepicker
    }
})
export default class OpremaVozila extends mixins(ComponentBaseMixin) {
    columns;
    options = {
        pagination: true,
        search: true,
        onClickRow: oprema => this.onClickRow(oprema)
    };
    dataSource = [];
    opremaVozila = new Oprema();

    async created() {
        this.columns = [
            {
                field: "slika",
                title: this.$i18n.t("slika"),
                formatter: (img) => img ? `<img src="${img}" width="80" height="80">` : ''
            },
            {field: "naziv", title: this.$i18n.t("naziv"), width: 300},
            {field: "serijskiBroj", title: this.$i18n.t("serijskiBroj")},
            {field: "proizvodjac", title: this.$i18n.t("proizvodjac")},
            {
                field: "istekGarancije",
                title: this.$i18n.t("istekGarancije"),
                formatter: value =>
                    value ? moment(new Date(value)).format("DD.MM.YYYY") : ""
            }
        ];
        this.dataSource = await this.loadData(() => dataProxy.vratiOpremu())();
    }

    formatter(date) {
        return this.$i18n.d(date, "short", "fr-FR");
    }

    onClickRow(row: Oprema) {
        this.opremaVozila = row;
    }

    kreirajNovo() {
        this.opremaVozila = new Oprema();
        (<HTMLElement>this.$refs.naziv).focus();
    }

    async obrisiOpremu() {
        const da = await this.confirmationNeeded(
            "da li zelite da obrisete opremu vozila"
        );
        if (da) {
            this.dataSource = await this.deleteData(() =>
                dataProxy.obrisiOpremu(this.opremaVozila.id)
            )();
            this.kreirajNovo();
        }
    }

    async sacuvajOpremu() {
        const isValid = await (<any>this.$refs.form).validate();
        if (isValid) {
            this.opremaVozila.id = await this.saveData(() =>
                dataProxy.sacuvajOpremu(this.opremaVozila)
            )();
            this.dataSource = await this.loadData(() => dataProxy.vratiOpremu())();
        }
    }
}
